import React, { lazy, Suspense, useCallback, useEffect, useState } from "react";
import { MdOutlineOpenInNew } from "react-icons/md";
import { FaTimes } from "react-icons/fa";

import { Button } from "../../components/ui/button.jsx";
import BgHero from "../../assets/images/banners/bg-hero.webp";

const SimuladorEconomia = lazy(() =>
  import("../../components/new-lp/NewSimuladorEconomia.jsx")
);
const Modal = lazy(() => import("../../components/ui/modal-default.jsx"));

const LoadingFallback = () => (
  <div className="w-full h-[400px] flex items-center justify-center">
    <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
  </div>
);

const ModalSuccessContent = React.memo(({ onClose, onRedirect }) => (
  <div className="flex flex-col h-[100vh] items-start justify-end md:justify-center">
    <div className="relative flex flex-col items-center justify-center w-[100vw] md:w-[360px] md:h-[310px] bg-white border rounded-t-3xl md:rounded-xl py-10 px-6">
      <button
        className="absolute top-4 right-4 text-black"
        onClick={onClose}
        aria-label="Fechar modal"
      >
        <FaTimes className="w-5 h-5" />
      </button>
      <MdOutlineOpenInNew size={40} color="red" />
      <p className="text-xl text-center font-medium px-4 mt-4 mb-10">
        Você será direcionado para o portal do nosso parceiro Thopen.
      </p>
      <Button
        variant="secondary"
        size="lg"
        className="w-full"
        onClick={onRedirect}
      >
        Entendi
      </Button>
    </div>
  </div>
));

const HeroTitle = React.memo(() => (
  <div className="lg:w-1/2 w-full flex-col justify-start items-start gap-6 inline-flex max-lg:pb-4">
    <div className="w-full flex-col justify-center items-start gap-4 flex">
      <h1 className="text-white w-full text-left text-2xl lg:text-4xl font-bold lg:leading-[52px] leading-[40px]">
        Um benefício exclusivo para os clientes TIM.
      </h1>
      <h1 className="text-white w-full text-left text-2xl lg:text-4xl font-thin lg:leading-[52px] leading-[40px]">
        Economize até 15% na sua conta de energia,
        <br />
        sem investimentos ou obras.
      </h1>
    </div>
  </div>
));

export default function Hero() {
  const [modalState, setModalState] = useState(null);

  const handleCloseModal = useCallback(() => {
    setModalState(null);
  }, []);

  const handleRedirect = useCallback(() => {
    handleCloseModal();
  }, [handleCloseModal]);

  useEffect(() => {
    // Preload o simulador para quando estiver fora do viewport
    const preloadSimulator = setTimeout(() => {
      import("../../components/new-lp/NewSimuladorEconomia.jsx");
    }, 1000);

    return () => clearTimeout(preloadSimulator);
  }, []);

  return (
    <div className="bg-secondary-color min-h-[80vh] bg-cover bg-no-repeat relative z-10">
      <img
        className="max-lg:hidden absolute inset-0 left-1"
        src={BgHero}
        alt="Background Hero"
        style={{ objectFit: "cover", width: "100%", height: "100%" }}
      />
      <div className="w-screen py-14 lg:py-28 flex justify-center items-center">
        <div className="w-full max-w-[85rem] px-3.5 md:px-5 flex flex-col lg:flex-row justify-between items-end gap-5">
          <HeroTitle />
          <Suspense fallback={<LoadingFallback />}>
            <SimuladorEconomia onOpenModal={() => setModalState("success")} />
          </Suspense>
          {modalState === "success" && (
            <Suspense fallback={null}>
              <Modal isOpen onClose={handleCloseModal}>
                <ModalSuccessContent
                  onClose={handleCloseModal}
                  onRedirect={handleRedirect}
                />
              </Modal>
            </Suspense>
          )}
        </div>
      </div>
      <div className="md:hidden absolute bottom-0 left-0 right-0 h-[150px] bg-gradient-to-b from-transparent via-white/20 to-white/60" />
    </div>
  );
}
